$(document).ready(function() {
  $(document).on('click', '.quick-info-button', function() {
    $.get(`/components/brands/quick_info?brand_id=${$(this).attr('brand_id')}&hs_brand_id=${$(this).attr('hs_brand_id')}`).done(function(html) {
      const quickInfoModal = $('#quick-info-modal')
      quickInfoModal.find('.modal-content').html(html)
      quickInfoModal.modal('show');
    });
  });
});
